export default __webpack_public_path__ + "static/media/logo.f010cd6d.svg";